import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  root: {
    padding: '10px',
    backgroundColor: '#f1f1f1',
    minHeight: 'calc(100vh - 70px)',
  },
});
